import { isMobile } from "@growtherapy/analytics";
import { isSafari as isBrowserSafari } from "../../utils";
import { HelpModalItem } from "./HelpModalItem";
import { BlockedPermissionDescription } from "../BlockedPermissionDescription";

export function BlockedPermissionsActionItem({
  isMobile: isMobileDevice,
  isSafari,
}: {
  isMobile: boolean;
  isSafari: boolean;
}) {
  return (
    <HelpModalItem
      heading="My camera and microphone aren’t working"
      description={
        <div className="flex flex-col gap-4">
          <BlockedPermissionDescription
            isMobile={isMobileDevice}
            isSafari={isSafari}
          />
        </div>
      }
    />
  );
}

export function BlockedPermissionsActionItemWrapper() {
  const isMobileDevice = isMobile(navigator.userAgent);
  const isSafari = isBrowserSafari();
  return (
    <BlockedPermissionsActionItem
      isMobile={isMobileDevice}
      isSafari={isSafari}
    />
  );
}
